module.exports = __webpack_public_path__ + "img/letter_qian.81705579.png";